export const sdahpf_routes = {
  "type": "FeatureCollection",
  "generator": "overpass-ide",
  "copyright": "The data included in this document is from www.openstreetmap.org. The data is made available under ODbL.",
  "timestamp": "2022-08-01T11:10:40Z",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "@id": "way/50219791",
        "gauge": "1676",
        "passenger_lines": "4",
        "railway": "rail",
        "service": "siding",
        "pf": "1"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3708649,
            22.5686726
          ],
          [
            88.3709768,
            22.5687168
          ],
          [
            88.3715132,
            22.5689285
          ],
          [
            88.3720554,
            22.5691288
          ],
          [
            88.3722123,
            22.5691708
          ],
          [
            88.3723877,
            22.5692079
          ],
          [
            88.3725966,
            22.5692394
          ],
          [
            88.3727701,
            22.5692612
          ],
          [
            88.3732407,
            22.569292
          ],
          [
            88.3735625,
            22.5693229
          ],
          [
            88.3738301,
            22.5693789
          ]
        ]
      },
      "id": "way/50219791"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/113611884",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "12"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3712399,
            22.5674525
          ],
          [
            88.3737389,
            22.5686432
          ],
          [
            88.376059,
            22.569713
          ],
          [
            88.3761958,
            22.5697727
          ],
          [
            88.376584,
            22.5699191
          ],
          [
            88.3769682,
            22.570055
          ],
          [
            88.3770147,
            22.5700761
          ]
        ]
      },
      "id": "way/113611884"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/113611891",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "13"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3713141,
            22.5673579
          ],
          [
            88.3749405,
            22.5690395
          ],
          [
            88.376132,
            22.5696163
          ],
          [
            88.3766103,
            22.5698823
          ],
          [
            88.3768583,
            22.5700012
          ]
        ]
      },
      "id": "way/113611891"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/113611899",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "14"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3730474,
            22.5680791
          ],
          [
            88.3739492,
            22.5684908
          ],
          [
            88.3741839,
            22.5685987
          ],
          [
            88.3749004,
            22.5689335
          ],
          [
            88.3753859,
            22.5692158
          ]
        ]
      },
      "id": "way/113611899"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203447453",
        "electrified": "contact_line",
        "frequency": "50",
        "gauge": "1676",
        "railway": "rail",
        "usage": "main",
        "voltage": "25000",
        "pf": "5"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3708424,
            22.5682646
          ],
          [
            88.3726866,
            22.5689758
          ],
          [
            88.3728629,
            22.5690388
          ],
          [
            88.3730477,
            22.5691006
          ],
          [
            88.3732061,
            22.5691439
          ],
          [
            88.3734231,
            22.5692014
          ],
          [
            88.37364,
            22.5692664
          ],
          [
            88.3739526,
            22.5693605
          ]
        ]
      },
      "id": "way/203447453"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203447454",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "2"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3735625,
            22.5693229
          ],
          [
            88.3732442,
            22.5692632
          ],
          [
            88.372539,
            22.5691344
          ],
          [
            88.3724078,
            22.5691076
          ],
          [
            88.3722657,
            22.5690746
          ],
          [
            88.3721219,
            22.5690246
          ],
          [
            88.3715681,
            22.5688173
          ],
          [
            88.3710221,
            22.5686071
          ],
          [
            88.3709195,
            22.5685676
          ]
        ]
      },
      "id": "way/203447454"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203447455",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding"
        ,
        "pf": "6"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3709257,
            22.5679277
          ],
          [
            88.3730016,
            22.5688789
          ],
          [
            88.3735729,
            22.5691488
          ],
          [
            88.3739269,
            22.5692999
          ],
          [
            88.3742676,
            22.5694213
          ],
          [
            88.3749167,
            22.5696095
          ],
          [
            88.3751581,
            22.5696789
          ]
        ]
      },
      "id": "way/203447455"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203447457",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "3"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3735015,
            22.5692768
          ],
          [
            88.3727744,
            22.5691466
          ],
          [
            88.3725872,
            22.5691086
          ],
          [
            88.3724427,
            22.5690796
          ],
          [
            88.3722752,
            22.5690396
          ],
          [
            88.3721806,
            22.5690098
          ],
          [
            88.3715791,
            22.5687868
          ],
          [
            88.3710455,
            22.5685717
          ],
          [
            88.370941,
            22.5685296
          ]
        ]
      },
      "id": "way/203447457"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203448625",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "10"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3730313,
            22.5684334
          ],
          [
            88.373693,
            22.5687787
          ],
          [
            88.3738143,
            22.5688415
          ],
          [
            88.3743155,
            22.5690793
          ],
          [
            88.3750021,
            22.5693988
          ],
          [
            88.3753937,
            22.5696167
          ],
          [
            88.3756261,
            22.5697296
          ],
          [
            88.3760106,
            22.5698743
          ]
        ]
      },
      "id": "way/203448625"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203448627",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "8"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.371273,
            22.5678554
          ],
          [
            88.3718545,
            22.5681269
          ],
          [
            88.3728979,
            22.5686211
          ],
          [
            88.3737884,
            22.5690384
          ],
          [
            88.374176,
            22.5692304
          ],
          [
            88.3747956,
            22.56953
          ],
          [
            88.3751581,
            22.5696789
          ]
        ]
      },
      "id": "way/203448627"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203448628",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "9"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3755091,
            22.5697381
          ],
          [
            88.3749056,
            22.569478
          ],
          [
            88.3744308,
            22.5692601
          ],
          [
            88.373999,
            22.5690495
          ],
          [
            88.372741,
            22.5684749
          ]
        ]
      },
      "id": "way/203448628"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203448629",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "7"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3747956,
            22.56953
          ],
          [
            88.3744791,
            22.5694409
          ],
          [
            88.3742484,
            22.5693666
          ],
          [
            88.3740754,
            22.5693038
          ],
          [
            88.3739353,
            22.5692477
          ],
          [
            88.3731943,
            22.568896
          ],
          [
            88.3712335,
            22.5679654
          ]
        ]
      },
      "id": "way/203448629"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/816991274",
        "electrified": "contact_line",
        "frequency": "50",
        "gauge": "1676",
        "railway": "rail",
        "usage": "main",
        "voltage": "25000",
        "pf": "4"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3735015,
            22.5692768
          ],
          [
            88.3726892,
            22.5690435
          ],
          [
            88.3724853,
            22.5689804
          ],
          [
            88.3721983,
            22.568885
          ],
          [
            88.3716372,
            22.5686702
          ],
          [
            88.3711092,
            22.568471
          ],
          [
            88.3710065,
            22.5684322
          ]
        ]
      },
      "id": "way/816991274"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/203448621",
        "gauge": "1676",
        "railway": "rail",
        "service": "siding",
        "pf": "11"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            88.3762035,
            22.5698194
          ],
          [
            88.375901,
            22.5696892
          ],
          [
            88.3751976,
            22.5693658
          ],
          [
            88.3738354,
            22.5687522
          ],
          [
            88.3712271,
            22.5674989
          ]
        ]
      },
      "id": "way/203448621"
    },

  ]
}